import * as React from 'react';
import ReportProblemOutlined from '@material-ui/icons/ReportProblemOutlined';
import { AnchorListItem } from '../../components/Nav/AnchorListItem';
import { AppName } from '@pec/aion-ui-core/interfaces/appName';
import { CommonRootState } from '@pec/aion-ui-core/combineReducers';
import { connect } from 'react-redux';
import { fetchContractorIncidentReport, IncidentReportInfo } from '@pec/aion-ui-core/slices/contractorIncidentReport';
import { NavLinkListItem } from '../../components/Nav/NavLinkListItem';
import { RootActions } from '@pec/aion-ui-core/combineActions';
import { ThunkDispatch } from 'redux-thunk';
import { withTranslation, WithTranslation } from 'react-i18next';

const { REACT_APP_NAME } = process.env;

type OwnProps = {
  organizationId: string;
  navExpanded: boolean;
};

const mapStateToProps = ({ contractorIncidentReport }: CommonRootState, { organizationId }: OwnProps) => ({
  incidentReportInfo: contractorIncidentReport.incidentReportInfo,
  hasFetched: contractorIncidentReport.hasFetched,
  isFetching: contractorIncidentReport.isFetching,
  organizationId
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<CommonRootState, null, RootActions>,
  { organizationId }: OwnProps
) => ({
  fetchIncidentReport: () => dispatch(fetchContractorIncidentReport({ contractorId: organizationId }))
});

type Props = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps> & OwnProps & WithTranslation;

class IncidentReportNavComponent extends React.Component<Props> {
  componentDidMount() {
    const { hasFetched, isFetching, fetchIncidentReport } = this.props;
    if (!hasFetched && !isFetching) {
      fetchIncidentReport();
    }
  }

  render() {
    const { incidentReportInfo, organizationId, navExpanded, t } = this.props;
    if (!incidentReportInfo) return null;

    const path = `/organizations/${organizationId}/process-automation/${
      (incidentReportInfo as IncidentReportInfo).automationId
    }/clientId/${(incidentReportInfo as IncidentReportInfo).clientOrganizationId}`;
    const label = t('components.subscriberLinks.reportIncident', 'Report Incident');

    return REACT_APP_NAME === AppName.AionProcessAutomationUI ? (
      <NavLinkListItem divider tooltip={!navExpanded} to={path} icon={<ReportProblemOutlined />}>
        {label}
      </NavLinkListItem>
    ) : (
      <AnchorListItem divider tooltip={!navExpanded} href={path} icon={<ReportProblemOutlined />}>
        {label}
      </AnchorListItem>
    );
  }
}

export const IncidentReportNav = connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(IncidentReportNavComponent));
